import { USER_LOAN_ESTIMATION_TYPE } from '@/config/constants';

type BorrowerLike = { loanEstimationType?: string | null } | null | undefined;

/** Commercial borrowers qualify on a Personal Financial Statement, not income. */
export function qualifiesWithPfs(user: BorrowerLike): boolean {
  return user?.loanEstimationType === USER_LOAN_ESTIMATION_TYPE.COMMERCIAL;
}

/** Investor and commercial borrowers get DSCR, bridge, fix & flip and commercial. */
export function usesInvestorPrograms(user: BorrowerLike): boolean {
  return (
    user?.loanEstimationType === USER_LOAN_ESTIMATION_TYPE.INVESTOR ||
    qualifiesWithPfs(user)
  );
}
